// extracted by mini-css-extract-plugin
export default {"card":"iZ-z","carouselContainer":"jZ-z","carouselContent":"kZ-z"};